import React, { useCallback } from 'react';
import cn from 'classnames';

import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';
import { ReactComponent as HamburgerIcon } from 'assets/icons/hamburger.svg';
import { useAppContext } from 'app/lib/AppContext';
import Analytics from 'app/lib/Analytics/Analytics';

import styles from './Header.module.css';

const Header = () => {
  const actions = useDispatcher();

  const { mode } = useAppContext();

  const cardStatus = useSelector((state) => state?.card?.meta?.status || 'init');
  const currentPage: number = useSelector((state) => state.flipbook.currentPage);
  const count: number = useSelector((state) => state.flipbook.count - 1);
  const cardState: string = useSelector((state) => state?.card?.meta?.state || '');
  const page: number = currentPage < 1 ? 1 : currentPage;

  const isReady = cardStatus === 'ready';
  const isShowPages = cardState === 'opened' && currentPage > 0;

  const isPreview = mode === 'preview';

  const handleShowDrawer = useCallback(() => {
    actions.drawer.setOpen();
    Analytics.track().tappedHamburgerMenu();
  }, [actions.drawer]);

  return (
    <div className={cn(styles.container, { [styles.isLoading]: !isReady, [styles.hidden]: isPreview })}>
      <div className={styles.menuButton}>
        <button
          type="button"
          data-action="mobileMenuOpen"
          onClick={handleShowDrawer}
        >
          <HamburgerIcon />
        </button>
      </div>
      <div className={styles.title}>
        <span>CardSnacks</span>
        <span>bite-sized greetings</span>
      </div>
      <div className={cn(styles.pages, { [styles.hide]: !isShowPages })}>{`${page}/${count}`}</div>
    </div>
  );
};

export default Header;
